import React from "react";
import AuthenticityTokenField from "../../../components/forms/AuthenticityTokenField";
import { SelectInput } from "../../../components/ui/FormControls";

type AdminBusinessBillingFormProps = {
  action: string;
  csrfToken: string;
  currentStatus: string;
  statusOptions: readonly string[];
};

export const AdminBusinessBillingForm: React.FC<
  AdminBusinessBillingFormProps
> = ({ action, csrfToken, currentStatus, statusOptions }) => (
  <form
    method="post"
    action={action}
    className="block w-full min-w-52 max-w-none"
    onSubmit={(e) => {
      const form = e.currentTarget;
      const select = form.elements.namedItem("billing_status");
      if (
        select instanceof HTMLSelectElement &&
        select.value === currentStatus
      ) {
        e.preventDefault();
      }
    }}
  >
    <AuthenticityTokenField csrfToken={csrfToken} />
    <input type="hidden" name="_method" value="patch" />
    <SelectInput
      compact
      name="billing_status"
      defaultValue={currentStatus}
      aria-label="Billing status"
      className="w-full min-w-52 py-2"
      onChange={(e) => {
        e.currentTarget.form?.requestSubmit();
      }}
    >
      {statusOptions.map((s) => (
        <option key={s} value={s}>
          {s.replace(/_/g, " ")}
        </option>
      ))}
    </SelectInput>
  </form>
);
